import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {getDeviceActivity} from "./api/api";
import {QUERY_KEY_DEVICE_ACTIVITY} from "./constants/queryKey";
import {useShowError} from "@hooks/useShowError/useShowError";


export const useGetDeviceActivityQuery = ({
                                              enabled,
                                              refetchInterval,
                                          }: {
    enabled?: boolean,
    refetchInterval?: number
}={}) => {
    const {onShowError} = useShowError()


    return useQuery({
        queryFn: () => getDeviceActivity( onShowError),
        queryKey:
            [
                QUERY_KEY_DEVICE_ACTIVITY,
            ],
        staleTime: 1000 * 60 * 30,
        enabled,
        placeholderData: keepPreviousData,
        refetchInterval,
    });
}
